import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "stage-tabs"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = {
  key: 1,
  class: "documents-content"
}
const _hoisted_5 = {
  key: 0,
  class: "spinner"
}
const _hoisted_6 = {
  key: 1,
  class: "documents-group"
}
const _hoisted_7 = { class: "documents-block" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "document-name" }
const _hoisted_10 = { class: "document-date" }
const _hoisted_11 = ["href"]
const _hoisted_12 = {
  key: 0,
  class: "document-row empty-row"
}
const _hoisted_13 = {
  key: 2,
  class: "spinner"
}
const _hoisted_14 = {
  key: 3,
  class: "empty-message"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    isOpen: $props.isOpen,
    onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
    classes: "stage-documents-modal height-limited"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "documents-header" }, [
          _createElementVNode("div", { class: "documents-header-title" }, "Stage Documents")
        ], -1)),
        (!$setup.loadingStages && !$setup.props.stageId && $setup.stages.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stages, (stage) => {
                return (_openBlock(), _createElementBlock("button", {
                  class: _normalizeClass(["stage-tab", { active: $setup.selectedStageId === stage._id }]),
                  key: stage._id,
                  onClick: ($event: any) => ($setup.selectStage(stage._id))
                }, "Stage " + _toDisplayString(stage.title), 11, _hoisted_3))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (!$setup.loadingStages || $setup.props.stageId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              ($setup.loadingDocs)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stageDocs, (doc, idx) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "document-row",
                          key: idx
                        }, [
                          _createElementVNode("div", {
                            class: "document-main",
                            onClick: ($event: any) => ($setup.openDoc(doc))
                          }, [
                            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "document-icon" }, null, -1)),
                            _createElementVNode("div", _hoisted_9, _toDisplayString($setup.getDocumentName(doc.fileName)), 1)
                          ], 8, _hoisted_8),
                          _createElementVNode("div", _hoisted_10, _toDisplayString($setup.formatDate(doc.modifiedDate)), 1),
                          _createElementVNode("a", {
                            class: "button download",
                            href: doc.url,
                            target: "_blank",
                            rel: "noopener noreferrer"
                          }, [...(_cache[2] || (_cache[2] = [
                            _createElementVNode("span", { class: "button-text" }, "Download", -1)
                          ]))], 8, _hoisted_11)
                        ]))
                      }), 128)),
                      ($setup.stageDocs.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[3] || (_cache[3] = [
                            _createElementVNode("div", { class: "document-name" }, "No documents available for this stage yet", -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true),
        ($setup.loadingStages && !$setup.props.stageId)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13))
          : _createCommentVNode("", true),
        (!$setup.loadingStages && !$setup.props.stageId && $setup.stages.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[4] || (_cache[4] = [
              _createElementVNode("div", { class: "name" }, "No stages available", -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["isOpen"]))
}